import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { PasscodeGate } from './components/ui/PasscodeGate';
import { Home } from './pages/Home';
import { Bids } from './pages/Bids';
import { Projects } from './pages/Projects';
import { AnnualPlan } from './pages/AnnualPlan';
import { ContractAwards } from './pages/ContractAwards';
import { UnsuccessfulBids } from './pages/UnsuccessfulBids';
import { ProcurementManual } from './pages/ProcurementManual';
import { SupplierRegistration } from './pages/SupplierRegistration';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { AboutAU } from './pages/AboutAU';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wip54z4dzc3c">
      <Routes data-id="element-1" data-mp="2wi5l9cv6edmo">
        <Route element={<Layout data-id="element-3" data-mp="28tw9l3rof699" />} data-id="element-2" data-mp="28u5x8kp911bs">
          <Route path="/" element={<Home data-id="element-5" data-mp="28sl5f2ubjwhm" />} data-id="element-4" data-mp="28t4mkhc5agul" />
          <Route path="/about" element={<About data-id="element-7" data-mp="23vulg4fe8gqx" />} data-id="element-6" data-mp="28s31dk1f0dz5" />
          <Route path="/about-au" element={<AboutAU data-id="element-9" data-mp="23t8gmcjw0fce" />} data-id="element-8" data-mp="23ujjma5idj2g" />
          <Route path="/projects" element={<Projects data-id="element-11" data-mp="3iiwfgpji5k3r" />} data-id="element-10" data-mp="3ik7g4ghnibqn" />
          <Route path="/bids" element={<PasscodeGate data-id="element-13" data-mp="3mkhlps1j704z">
                <Bids data-id="element-14" data-mp="3mjq1tehaqquj" />
              </PasscodeGate>} data-id="element-12" data-mp="3ijpcgysnsv8p" />
          <Route path="/procurement/annual-plan" element={<AnnualPlan data-id="element-16" data-mp="3relv0hy9rk98" />} data-id="element-15" data-mp="3rdarmj8qkein" />
          <Route path="/procurement/contract-awards" element={<ContractAwards data-id="element-18" data-mp="2zl39tfhhuw2o" />} data-id="element-17" data-mp="6hp9c27i9cj" />
          <Route path="/procurement/unsuccessful-bids" element={<UnsuccessfulBids data-id="element-20" data-mp="33m5b01uz1i7a" />} data-id="element-19" data-mp="2zm4zaoz9bl3x" />
          <Route path="/procurement/manual" element={<ProcurementManual data-id="element-22" data-mp="38lrs4mdx7ild" />} data-id="element-21" data-mp="33n6xd2hftr4b" />
          <Route path="/procurement/supplier-registration" element={<SupplierRegistration data-id="element-24" data-mp="3dle3sre3oqs2" />} data-id="element-23" data-mp="38kqbm2e4y3w9" />
          <Route path="/contact" element={<Contact data-id="element-26" data-mp="nvj179a902mk" />} data-id="element-25" data-mp="3dm5ze27p6oic" />
        </Route>
      </Routes>
    </BrowserRouter>;
}